<template lang="pug">
  .footprint-slides
    .swiper-container(ref="swiper")
      .swiper-wrapper
        .swiper-slide(v-for="(ex, i) in $t(`exhibits`)" :key="i")
          .card
            img(:src="ex.icon")
          .name {{ex.name}}



</template>

<script>
import Swiper from 'swiper'
import ResizeService from '@/services/ResizeService'
import IntroCard from '@/components/home/IntroCard'
import EventsCard from '@/components/home/EventsCard'
import gsap from 'gsap'
import b from '@/assets/icons/b.png'
import c from '@/assets/icons/c.png'
import d from '@/assets/icons/d.png'
import e from '@/assets/icons/e.png'
import f from '@/assets/icons/f.png'
import g from '@/assets/icons/g.png'
import h from '@/assets/icons/h.png'
export default {
  name: 'FootprintSlides',
  components: { EventsCard, IntroCard },
  data() {
    return {}
  },
  mounted() {
    setTimeout(() => {
      this.init()
    })
  },
  methods: {
    init() {
      this.swiper = new Swiper(this.$refs.swiper, {
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 30,
        freeMode: true,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
      })
    },
  },
}
</script>

<style scoped lang="sass">
@import "~swiper/swiper-bundle.min.css"
@import "src/styles/common.sass"
.footprint-slides
  position: relative
  width: 100%
  .swiper-container
    //overflow: visible
    position: relative
    //background: #f7a41a
    width: 100%
    //height: 100%
    .swiper-slide
      //background: #fff
      width: pxToRem(160)
      //height: pxToRem(180)
      .card
        width: pxToRem(160)
        height: pxToRem(160)
        background: #3a54a2
        overflow: hidden
        border-radius: pxToRem(16)
        img
          width: 100%
      .name
        margin-top: pxToRem(20)
        font-family: $ff-cn
        text-align: center
        font-size: pxToRem(26)
        line-height: pxToRem(40)
        letter-spacing: 0
        color: black
</style>
